import { Picker } from "antd-mobile";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import "./index.less";
import { cloneDeep } from "lodash";
import { language } from "@/utils/language";  
// 城市题
export default function City(props) {
  const [cityList, setCityList] = useState([]);
  const [answer, setAnswer] = useState(); // 用于显示的地区文字
  const [hashMap, setHashMap] = useState({});

  const {
    info: { cityShowType, region, id },
  } = props;

  useEffect(() => {
    try {
      const { answer } = props;
      const { province, city, district } = answer[id];
      const text1 = province?.text.split(":")?.[1];
      const text2 = city?.text.split(":")?.[1];
      const text3 = district?.text.split(":")?.[1];
      switch (cityShowType) {
        case 0:
          setAnswer([text1, text2, text3].join(","));
          break;
        case 1:
          setAnswer([text1, text2].join(","));
          break;
        case 2:
          setAnswer([text1].join(","));
          break;
        case 3:
          setAnswer([text2, text3].join(","));
          break;
        case 4:
          setAnswer([text2].join(","));
          break;
        case 5:
          setAnswer([text3].join(","));
          break;
        default:
          break;
      }
    } catch (error) {
      console.log("27 line: ", error.message);
    }
  }, [props.answer]);

  useEffect(() => {
    axios.get(`/china.json`).then(({ data: { data } }) => {
      const other = { label: "其他", value: "-1" };
      const map = {};
      const setMap = (level) => (item) => {
        item.level = level;
        map[item.value] = item;
        if (item.children) item.children.map(setMap(level + 1));
      };
      data.map(setMap(1));
      map["-1"] = other;
      setHashMap(map);

      switch (cityShowType) {
        case 0:
          {
            const list = data.filter((item) => {
              if (region[0].codes.includes(item.value)) {
                item.children = (item.children || []).filter((item) => {
                  if (region[1].codes.includes(item.value)) {
                    item.children = (item.children || []).filter((item) => {
                      if (region[2].codes.includes(item.value)) {
                        return item;
                      }
                      return null;
                    });
                    item.children.push(other);
                    return item;
                  }
                  return null;
                });
                item.children.push(other);
                return item;
              }
            });
            setCityList([...list, other]);
          }
          break;
        case 1:
          {
            const list = data.filter((item) => {
              if (region[0].codes.includes(item.value)) {
                item.children = (item.children || []).filter((item) => {
                  if (region[1].codes.includes(item.value)) {
                    delete item.children;
                    return item;
                  }
                  return null;
                });
                item.children.push(other);
                return item;
              }
            });
            setCityList([...list, other]);
          }
          break;
        case 2:
          {
            const list = data.filter((item) => {
              if (region[0].codes.includes(item.value)) {
                delete item.children;
                return item;
              }
            });
            setCityList([...list, other]);
          }
          break;
        case 3:
        case 4:
          {
            const list = region[1].codes
              .filter((n) => n !== "-1")
              .map((code) => {
                const result = cloneDeep(map[code]);
                if (result.children) result.children.push(other);
                return result;
              });
            setCityList([...list, other]);
          }
          break;
        case 5:
          {
            const list = region[2].codes
              .filter((n) => n !== "-1")
              .map((code) => {
                const result = cloneDeep(map[code]);
                // result.children.push(other);
                return result;
              });
            setCityList([...list, other]);
          }
          break;
        default:
      }
    });
  }, [cityShowType, region]);

  const onOk = useCallback(
    (value) => {
      if (cityShowType === 5) {
        const code = value[0];
        const { label } = hashMap[code];
        setAnswer(label);
        props.changeAnswer({ district: { text: `${code}:${label}` } });
      } else if (cityShowType === 4) {
        console.log("136 line");
        const code = value[0];
        const { label } = hashMap[code];
        setAnswer(label);
        props.changeAnswer({ city: { text: `${code}:${label}` } });
      } else if (cityShowType === 3) {
        const [cityCode, districtCode] = value;
        if (!districtCode) {
          const { label } = hashMap[cityCode];
          setAnswer(label);
          props.changeAnswer({ city: { text: `${cityCode}:${label}` } });
        } else {
          const { label: cityLabel } = hashMap[cityCode];
          const { label: districtLabel } = hashMap[districtCode];
          setAnswer(`${cityLabel}, ${districtLabel}`);
          props.changeAnswer({
            city: { text: `${cityCode}:${cityLabel}` },
            district: { text: `${districtCode}:${districtLabel}` },
          });
        }
      } else if (cityShowType === 2) {
        const code = value[0];
        const { label } = hashMap[code];
        setAnswer(label);
        props.changeAnswer({ province: { text: `${code}:${label}` } });
      } else if (cityShowType === 1) {
        const [provinceCode, cityCode] = value;
        if (!cityCode) {
          const { label } = hashMap[provinceCode];
          setAnswer(label);
          props.changeAnswer({
            province: { text: `${provinceCode}:${label}` },
          });
        } else {
          const { label: provinceLabel } = hashMap[provinceCode];
          const { label: cityLabel } = hashMap[cityCode];
          setAnswer(`${provinceLabel}, ${cityLabel}`);
          props.changeAnswer({
            province: { text: `${provinceCode}:${provinceLabel}` },
            city: { text: `${cityCode}:${cityLabel}` },
          });
        }
      } else if (cityShowType === 0) {
        const [provinceCode, cityCode, districtCode] = value;
        if (!districtCode) {
          if (!cityCode) {
            const { label } = hashMap[provinceCode];
            setAnswer(label);
            props.changeAnswer({
              province: { text: `${provinceCode}:${label}` },
            });
          } else {
            const { label: provinceLabel } = hashMap[provinceCode];
            const { label: cityLabel } = hashMap[cityCode];
            setAnswer(`${provinceLabel}, ${cityLabel}`);
            props.changeAnswer({
              province: { text: `${provinceCode}:${provinceLabel}` },
              city: { text: `${cityCode}:${cityLabel}` },
            });
          }
        } else {
          const { label: provinceLabel } = hashMap[provinceCode];
          const { label: cityLabel } = hashMap[cityCode];
          const { label: districtLabel } = hashMap[districtCode];
          setAnswer(`${provinceLabel}, ${cityLabel}, ${districtLabel}`);
          props.changeAnswer({
            province: { text: `${provinceCode}:${provinceLabel}` },
            city: { text: `${cityCode}:${cityLabel}` },
            district: { text: `${districtCode}:${districtLabel}` },
          });
        }
      }
    },
    [cityShowType, hashMap, props]
  );

  return (
    <div className="city">
      <div className="q-content">
        <div className="q-content-options">
          <Picker
            extra="请选择(可选)"
            className="q-content-picker"
            data={cityList.filter((n) => n)}
            title={ language().select_city}
            onOk={onOk}
            cols={
              [0].includes(cityShowType)
                ? 3
                : [1, 3].includes(cityShowType)
                ? 2
                : 1
            }
            onDismiss={(e) => console.log("dismiss", e)}
          >
            <div className="q-content-option">{answer ||language().select_city}</div>
          </Picker>
        </div>
      </div>
    </div>
  );
}
